import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { api, apiError } from "../../lib/api";

const TOPICS = ["Pasajes", "Encomiendas", "Horarios", "Otro"];
const EMPTY = { name: "", email: "", phone: "", topic: "Pasajes", message: "" };

export const ContactForm = () => {
  const [f, setF] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", f);
      toast.success("¡Gracias! Recibimos tu mensaje y te respondemos a la brevedad.");
      setF(EMPTY);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-4 rounded-[28px] bg-white p-6 ring-1 ring-black/5 md:p-10">
      <div className="flex flex-wrap gap-2">
        {TOPICS.map((t) => (
          <button type="button" key={t} onClick={() => setF({ ...f, topic: t })} data-testid={`contact-topic-${t.toLowerCase()}`} className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-300 ${f.topic === t ? "bg-[var(--forest)] text-white" : "bg-[var(--paper)] hover:bg-[#e6e5dc]"}`}>{t}</button>
        ))}
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <Input data-testid="contact-name-input" placeholder="Nombre" required minLength={2} value={f.name} onChange={set("name")} className="h-12 rounded-xl" />
        <Input data-testid="contact-phone-input" placeholder="Teléfono (opcional)" value={f.phone} onChange={set("phone")} className="h-12 rounded-xl" />
      </div>
      <Input data-testid="contact-email-input" type="email" placeholder="Email" required value={f.email} onChange={set("email")} className="h-12 rounded-xl" />
      <Textarea data-testid="contact-message-input" placeholder="¿En qué te ayudamos?" required minLength={5} rows={5} value={f.message} onChange={set("message")} className="rounded-xl" />
      <button data-testid="contact-submit-button" disabled={loading} className="group flex h-14 w-full items-center justify-center gap-2 rounded-2xl bg-[var(--forest)] font-bold text-white transition-colors hover:bg-[var(--forest-2)]">
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />} Enviar mensaje
      </button>
    </form>
  );
};
